export const SystemVariableType = {
  APPLICATION_CATEGORY: 'applicationCategory',
  BUSINESS_UNIT: 'businessUnit',
  TEAM: 'team',
  SISIC: 'sisic',
  VENDOR_CATEGORY: 'vendorCategory',
  HS_CODE: 'hsCode',
}
